module.exports = __webpack_public_path__ + "img/YR.45135d01.png";